import React, { ChangeEvent, useMemo } from 'react';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { getEnv } from '../../../../lib/utils/environment';
import styles from './CheckOutDisclaimer.module.css';
import { Checkbox } from '../../Shared';

import { TEST_ID_SHIPPING_DISCLAIMER } from './tests/CheckOutDisclaimerTestIds';
const orderLegalText =
  // eslint-disable-next-line max-len
  'Shipping fees apply to non-contiguous US shipments and orders under $49. Foreign exchange or transaction fees may apply.';

// eslint-disable-next-line max-len
const REFILL_INTRO_CHECKBOX_LABEL =
  'I understand and agree that my purchase includes a recurring FabFitFun Membership. I also understand and agree that my purchase includes a recurring product subscription.';
// eslint-disable-next-line max-len
const INTRO_CHECKBOX_LABEL =
  'I understand and agree that my purchase includes a recurring FabFitFun Membership.';

interface CheckOutDisclaimerProps {
  disclaimerPriceIncreaseFF?: boolean;
  subscribable?: boolean;
  hasIntro?: boolean;
  acceptedTerms?: boolean;
  setAcceptedTerms?: (value: boolean) => void;
}

const CheckOutDisclaimer: React.FunctionComponent<CheckOutDisclaimerProps> = ({
  disclaimerPriceIncreaseFF,
  subscribable,
  hasIntro,
  acceptedTerms,
  setAcceptedTerms,
}) => {
  const { name } = getEnv();
  const handleSetAcceptedTerms = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    if (setAcceptedTerms) {
      setAcceptedTerms(checked);
    }
  };

  const getCheckboxLabel = useMemo(() => {
    if (hasIntro && subscribable) return REFILL_INTRO_CHECKBOX_LABEL;
    return INTRO_CHECKBOX_LABEL;
  }, [hasIntro, subscribable]);

  const introCheckoutDisclaimerName = disclaimerPriceIncreaseFF
    ? DISCLAIMER_NAMES.introCheckoutPriceIncrease
    : DISCLAIMER_NAMES.introCheckout;

  return (
    <>
      <p className={styles.orderLegalTextLight} data-testid={TEST_ID_SHIPPING_DISCLAIMER}>
        {orderLegalText}
      </p>
      {(subscribable || hasIntro) && (
        <div className={styles.disclaimerContainer}>
          {hasIntro && (
            <div data-testid={`${introCheckoutDisclaimerName}-disclaimer`}>
              <Disclaimer name={introCheckoutDisclaimerName} env={name} />
            </div>
          )}
          {subscribable && (
            <div data-testid={`${DISCLAIMER_NAMES.refillCheckout}-disclaimer`}>
              <Disclaimer name={DISCLAIMER_NAMES.refillCheckout} env={name} />
            </div>
          )}
          {hasIntro && (
            <div className={styles.checkboxContainer}>
              <Checkbox
                label={getCheckboxLabel}
                handleChange={handleSetAcceptedTerms}
                value={acceptedTerms ?? false}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CheckOutDisclaimer;
